import './Philosophy.css'

const pillars = [
  {
    title: 'Innovation for All',
    description: 'Taking complex "code" and making it "Jana-friendly."',
    icon: '💡'
  },
  {
    title: 'Quality First',
    description: 'Because "Jana" (the people) deserves code that is tested and bug-free.',
    icon: '⭐'
  },
  {
    title: 'Scale for Everyone',
    description: 'Cloud-native architectures that grow with your user base without breaking the bank.',
    icon: '⚙️'
  }
]

const Philosophy = () => {
  return (
    <section id="philosophy" className="philosophy section">
      <div className="container">
        <div className="philosophy-header">
          <p className="section-label">OUR PHILOSOPHY</p>
          <h2 className="section-title">
            Built on <span className="highlight-orange">Three Pillars</span>
          </h2>
        </div>

        <div className="philosophy-grid">
          {pillars.map((pillar, index) => (
            <div key={index} className="philosophy-card">
              <div className="philosophy-icon-wrapper">
                <div className="philosophy-icon">{pillar.icon}</div>
              </div>
              <h3 className="philosophy-title">{pillar.title}</h3>
              <p className="philosophy-description">{pillar.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Philosophy
